Shopify.theme.jsCart = {
  init: function ($section) {
    this.$section = $section;
    $(document).off('click.giftboxCart')
      .on('click.giftboxCart', '[data-cart-page-delete], .linkedDeleteBtn', function (event) {
        event.preventDefault();
        const $row = $(this).closest('.cart__card[data-cart-item]');
        Shopify.theme.cartFlow.change($row.attr('data-cart-item'), 0, $row);
        return false;
      });
    $('#cart_form').off('keydown.giftboxCart').on('keydown.giftboxCart', function (event) {
      if (event.key === 'Enter' && $(event.target).hasClass('quantity-input')) {
        event.preventDefault();
        $(event.target).trigger('change');
      }
    });
    document.dispatchEvent(new CustomEvent('cartUpdated', {detail: {message: 'Cart was updated'}}));
  },
  removeFromCart: function (lineID) {
    const $row = $('.cart__card[data-cart-item]').filter(function () {
      return $(this).attr('data-line-item') === String(lineID);
    }).first();
    if ($row.length) Shopify.theme.cartFlow.change($row.attr('data-cart-item'), 0, $row);
  },
  updateView: function () {
    // Partial row replacements were losing prices and quantities after app changes.
    window.location.reload();
  },
  unload: function () {
    $(document).off('.giftboxCart');
    $('#cart_form').off('.giftboxCart');
  }
};
